module.exports = __webpack_public_path__ + "04fd77646ca5889e0ae5e7fe26d9f048.svg";